import { Component, OnDestroy, ViewChild } from '@angular/core';

import { PoDialogConfirmOptions, PoDialogService, PoDialogType, PoMenuComponent, PoMenuItem, PoMenuItemBadge, PoToolbarAction, PoToolbarProfile, PoNotificationService, PoNotification, PoToasterOrientation, PoToasterMode } from '@po-ui/ng-components';
import { MenuService } from './core/menu/menu.service';
import { Observable, Subscription } from 'rxjs';
import { User } from './core/user/user';
import { UserService } from './core/user/user.service';
import { environment } from '../environments/environment';
import { ShortcutService } from './core/shortcut/shortcut.service';
import { AuthService } from './core/auth/auth.service';
import { NotificationService } from './core/notifications/notification.service';
import { TokenService } from './core/token/token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnDestroy {

  @ViewChild('poMenu') poMenu!: PoMenuComponent;

  private shortcutSubscription: Subscription;
  private hubConnected = false;

  loading = false;
  logo = '';
  shortLogo = '';
  customerName = '';
  tagVersion = '';
  aprovaFinanceiroCount: any;
  isLoggedIn$: Observable<boolean>;
  user$: Observable<User | null>;
  userInfo: User | null = null;
  userName: string = "";
  poDialogAlertOptions: PoDialogConfirmOptions =
    {
      title: 'Confirmação de Saída',
      message: 'Deseja realmente sair do sistema?',
      confirm: () => this.logOut(),
      cancel: () => console.log('Cancelado')
    }
  menus: PoMenuItem[] = [];

  profile: PoToolbarProfile = {

    avatar: 'https://po-ui.io/assets/graphics/logo-po.png',
    subtitle: this.userInfo?.name!,
    title: this.userInfo?.email!
  };

  profileActions: Array<PoToolbarAction> = [
    { icon: 'po-icon-user', label: 'Perfil' },
    { icon: 'po-icon-company', label: 'Info da Empresa' },
    { icon: 'po-icon-settings', label: 'Configuracões', url: 'config' },
    { icon: 'po-icon-exit', label: 'Logout', type: 'danger', separator: true, action: () => this.logOut() }
  ];

  notificationActions2: Array<PoToolbarAction> = [
  ];

  notificationActions: Array<PoToolbarAction> = [
    {
      icon: 'po-icon-news',
      label: 'Novidades',
      type: 'default'
    },
    {
      icon: 'po-icon-message',
      label: 'Enviar mensagem',
      type: 'default',
    }
  ];



  constructor(private readonly menuService: MenuService,
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly tokenService: TokenService,
    private readonly poDialogService: PoDialogService,
    private readonly poNotificationService: PoNotificationService,
    private readonly notificationService: NotificationService,
    private readonly shortcutService: ShortcutService) {

    const savedTheme = localStorage.getItem('theme');

    if (savedTheme === 'dark') {
      document.body.classList.add('dark-theme');
    } else if (savedTheme === 'light') {
      document.body.classList.remove('dark-theme');
    } else {
      // se nunca escolheu, usa o tema do sistema
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

      if (prefersDark) {
        this.logo = 'logo-white.png';
        document.body.classList.add('dark-theme');
      }
    }

    //Criação de Atalhos de Teclado...
    this.shortcutSubscription = this.shortcutService.getShortcuts().subscribe((event: KeyboardEvent) => {

      if (event.ctrlKey && event.key === 'q') {
        event.preventDefault();

        this.poMenu.collapsed = !this.poMenu.collapsed;
      }
      if (event.ctrlKey && event.key === 'l') {
        event.preventDefault();

        this.poDialogService.openDialog(PoDialogType.Confirm, this.poDialogAlertOptions)
      }
    });

    this.menuService.reconstruirMenuObservable.subscribe(() => {
      this.menuService.getMenuSchema().subscribe({
        next: (menus) => {
          this.loading = false;
          this.menus = menus;
          localStorage.setItem('menuSchema', JSON.stringify(menus));
        },
        error: (error) => {
          console.error('Erro ao carregar o menu:', error);
          this.loading = false;
          this.poNotificationService.error('Erro ao carregar o menu. Por favor, tente novamente mais tarde.');
        }
      })

      this.renderizaTela();
    });

    this.user$ = this.userService.getUser();
    this.isLoggedIn$ = this.userService.isLoggedIn;

    this.renderizaTela();
  }

  renderizaTela() {
    this.buildProfileActions();

    this.tagVersion = environment.tagVersion;

    // this.menuService.getMenuSchema().subscribe((menus) => {
    //   this.menus = menus;
    // });

    this.user$ = this.userService.getUser();
    this.isLoggedIn$ = this.userService.isLoggedIn;

    this.user$.subscribe(x => {
      this.userInfo = x,
        this.userName = x?.name as string

      const menus = JSON.parse(localStorage.getItem('menuSchema') || '[]');
      if (menus.length > 0)
        this.menus = menus;

      this.profile = {
        avatar: 'https://po-ui.io/assets/graphics/logo-po.png',
        title: x?.name!,
        subtitle: x?.email!
      };
      const token = this.tokenService.getToken();
      if (token && !this.hubConnected) {
        this.notificationService.startConnection(token);
        this.notificationService.onMessage((msg: any) => {
          console.log('Mensagem recebida:', msg);

          if (msg.type == '0')
            this.poNotificationService.success(msg);
          else if (msg.type == '1')
            this.poNotificationService.information(msg);
          else if (msg.type == '2')
            this.poNotificationService.warning(msg);
          else if (msg.type == '3')
            this.poNotificationService.error(msg);
        });

        this.hubConnected = true;
      }

    });

  }

  private findMenuItem(menus: PoMenuItem[], link: string): PoMenuItem | undefined {
    for (let menu of menus) {

      if (menu.link === link) {
        return menu;
      }

      if (menu.subItems) {
        const found = this.findMenuItem(menu.subItems, link);

        if (found) {
          return found;
        }

      }
    }
    return undefined;
  }
  logOut() {
    //this.userService.logout();
    this.authService.logout();
  }

  ngOnDestroy(): void {
    if (this.shortcutSubscription) {
      this.shortcutSubscription.unsubscribe();
    }
  }

  getThemeIcon() {
    const theme = localStorage.getItem('theme');
    return theme == 'dark'
      ? 'an an-sun'
      : 'an an-moon';
  }

  getThemeName() {
    const theme = localStorage.getItem('theme');
    return theme == 'dark'
      ? 'Modo Claro'
      : 'Modo Escuro';
  }

  buildProfileActions() {
    this.profileActions = [
      { icon: 'po-icon-user', label: 'Perfil' },
      { icon: 'po-icon-company', label: 'Info da Empresa' },
      { icon: 'po-icon-settings', label: 'Configuracões', url: 'config' },
      { icon: this.getThemeIcon(), label: this.getThemeName(), action: () => this.toggleTheme() },
      { icon: 'po-icon-exit', label: 'Logout', type: 'danger', separator: true, action: () => this.logOut() }
    ];
    this.logo = this.getLogo();
  }

  getLogo() {
    const theme = localStorage.getItem('theme');
    return theme == 'dark'
      ? 'logo_white.png'
      : 'logo.png';
  }

  toggleTheme() {
    const body = document.body;
    const isDark = body.classList.contains('dark-theme');

    if (isDark) {
      body.classList.remove('dark-theme');
      localStorage.setItem('theme', 'light');
      this.buildProfileActions();
    } else {
      body.classList.add('dark-theme');
      localStorage.setItem('theme', 'dark');
      this.buildProfileActions();
    }
  }
}
